import React from 'react'
import {connect} from 'react-redux'
import classnames from 'classnames'
import underscore from 'underscore'
import { SelectWrapper } from '../shared/select/SelectWrap'
import {setClientSubAction, b2bCompanySwitchSubActions, setB2bCompanyClientAction, setB2bCompanyClientSubAction} from 'state/actions'

@connect(state => ({
	policyActions: state.b2bCompany.policyActions
}))
export default class B2bCompanyClientActionSelector extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		policyActions: React.PropTypes.object.isRequired,
		currentClientAction: React.PropTypes.string,
		actionNames: React.PropTypes.object
	}
	updateClientAction(currentClientAction) {
		const {dispatch, policyActions} = this.props
		const oenCategoryGroup = policyActions && policyActions[currentClientAction] && policyActions[currentClientAction].actionCategories || []
        let policySubActions = {}
		for (const cSubAction of oenCategoryGroup || []) {
			policySubActions[cSubAction.category] = cSubAction
        }
		dispatch(setB2bCompanyClientSubAction(""))
		dispatch(b2bCompanySwitchSubActions(policySubActions))
		dispatch(setB2bCompanyClientAction(currentClientAction))
	}
	render() {
		const {currentClientAction, actionNames} = this.props
		let options = []
		if (!underscore.isEmpty(actionNames)) {
			const keys = Object.keys(actionNames)
			keys && keys.forEach((key) => {
				options.push({
					label: actionNames[key],
					value: key,
				})
			})
		}
		return (
			<span className={classnames('B2bCompanyClientActionSelector', this.props.styleName)}>
				{options.length >= 1 ? (
					<SelectWrapper
						value={currentClientAction}
						options={options}
						isClearable={false}
						onChange={item => this.updateClientAction(item.value)}
					/>
				) : (
					<span>{currentClientAction}</span>
				)}
			</span>
		)
	}
}



// WEBPACK FOOTER //
// ./components/b2bCompany/b2bCompanyClientActionSelector.jsx